    <template >
  <div v-role="roles">
<!--=========================informacao de actividades bloaqueadas =======================-->
  <div>
  <div class="formPosition">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <template>

      <!--  classes em aue se tem discplinas  -->
      <v-container

        v-if="!disciplinas.length"
        class="grey lighten-5"
      >
        <v-row no-gutters>
          <v-col >
            Lancar nota -
            <strong>3º Trimestre</strong>
            <br />

            <span v-if="listaDeClassesPorLancarNotas.length && !progresso">Escolhe uma classe para encontrar a turma</span>

            <v-icon v-if="!progresso" large color="green darken-2">forward</v-icon>
            <span v-if="!listaDeClassesPorLancarNotas.length && !progresso">Nenhuma turma para ser exibida.</span>
            <br />
            <span v-if="!listaDeClassesPorLancarNotas.length && !progresso">- Certifica-se de que tenha as permissôes correctas.</span>
            <br v-if="!listaDeClassesPorLancarNotas.length && !progresso" />
            <span
              v-if="!listaDeClassesPorLancarNotas.length && !progresso"
            >- Caso estejas logado com uma conta de Sub-director pedagógico ou de coordenador, provalvemente nao existam turmas criadas. Deverá cria-las e atribuir a no mínimo um professor.</span>
            <br v-if="!listaDeClassesPorLancarNotas.length" />
            <span
              v-if="!listaDeClassesPorLancarNotas.length && !progresso"
            >- Caso estejas logado com uma conta de professor, pode não ter sido atrbuida turmas a sí. Contacte o Sub-director pedagógico. Obrigado</span>
            <br v-if="!listaDeClassesPorLancarNotas.length && !progresso" />

            <div class="text-center" v-if="progresso">

                <!--================PROGRESSO===========================-->
                  <span v-if="progresso">Procurando por turmas , por favor aguarde...</span>

                  <v-progress-circular
                          v-if="progresso"
                          indeterminate
                          color="green"
                  ></v-progress-circular>

              <!--===================/Progresso=====================-->

            </div>

            <div v-if="listaDeClassesPorLancarNotas.length && !progresso" class="text-center">

              <v-btn
                @click="classe(1)"
                v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===1).length && !progresso"
                class="ma-2"
                outlined
                color="indigo"
              >
                <v-icon small color="primary">filter_1</v-icon>10ª classe
              </v-btn>
              <v-btn
                @click="classe(2)"
                v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===2).length && !progresso"
                class="ma-2"
                outlined
                color="indigo"
              >
                <v-icon small color="primary">filter_2</v-icon>11ª classe
              </v-btn>
              <v-btn
                @click="classe(3)"
                v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===3).length && !progresso"
                class="ma-2"
                outlined
                color="indigo"
              >
                <v-icon small color="primary">filter_3</v-icon>12ª classe
              </v-btn>
            </div>
          </v-col>

        </v-row>
      </v-container>

      <!--  list turmas  -->
      <v-container>
        <v-row no-gutters>
          <v-col>
            <!-- v-if="!listEstudantfromPauta.length"   v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico).length"   -->
            <template
              v-if="!disciplinas.length&&listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico).length"
            >
              <v-container class="text-md-left">
                <v-row no-gutters>
                  <v-col>
                    <v-card class="d-flex flex-row mb-6" max-width="400" tile>
                      <v-list flat>
                        <v-subheader>você tem {{listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico).length}} Turma(s) da {{_classe }}. clica em uma para prosseguir</v-subheader>
                        <v-list-item-group v-model="item" color="primary">
                          <v-list-item
                            v-for="(item, i) in listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico)"
                            :key="i"
                          >
                            <v-list-item-icon>
                              <v-icon v-text="item.icon"></v-icon>
                            </v-list-item-icon>

                            <v-list-item-content color="primary" dark v-on="on">
                              <v-list-item-title
                                v-text="item.descricao"
                                @click="findDisciplinaInProfDisc(item)"
                              ></v-list-item-title>

                              <v-list-item-subtitle @click="findDisciplinaInProfDisc(item)">
                                <strong>{{item.estudantes}}</strong>
                                estudantes na turma - Periodo {{item.periodo}}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-col>

          <v-col></v-col>
        </v-row>
      </v-container>

      <!--  list disciplinas  -->
      <v-container v-if="disciplinas.length && !listEstudantfromPauta.length">
        <v-row no-gutters>
          <v-col>
            <!-- v-if="!listEstudantfromPauta.length"   -->

            <template v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico).length">
              <v-container class="text-md-left">
                <v-row no-gutters>
                  <v-col>
                    <v-card class="d-flex flex-row mb-6" max-width="400" tile>
                      <v-btn
                        @click="backToTurmaList"
                        class="mx-2"
                        fab
                        dark
                        color="primary"
                        v-on="on"
                      >
                        <v-icon dark>arrow_back</v-icon>
                      </v-btn>
                      <v-list flat>
                        <v-subheader>
                          você tem {{disciplinas.length}} disciplina(s) na {{this.$store.state.turma}} . Seleciona uma para prosseguir
                          <br />
                          <br />
                        </v-subheader>
                        <v-list-item-group v-model="item" color="primary">
                          <v-list>
                            <v-list-item v-for="(item, index) in disciplinas" :key="index">
                              <v-list-item-title
                                v-text="item.descricao"
                                @click="pautaByTurma(item)"
                              ></v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-col>

          <v-col></v-col>
        </v-row>
      </v-container>
      <!--  fim discp  -->
    </template>
  <!--=========================DIALOGO DE DESBLOQUEIO DA PAUTA============================================-->

         <template>
              <v-row justify="center">
                <v-dialog
                  v-model="dialogoDisabilita"
                  max-width="500"
                >
                  <v-card>
                    <v-card-title class="headline">Desbloquear  Pauta</v-card-title>

                    <v-card-text>
                     <strong> NOTA:</strong>----Ao desbloquear  esta pauta, ela estará disponível para o lançamento de notas,<strong> pretende continuar</strong>?
                    <v-row>
                       <v-col cols="12" md="6">
                           <v-combobox
                            :rules="ruleRequired"
                            v-model="editedItem.dayValidity"
                            :items="diasDesbloqueio"
                            item-value="id"
                            item-text="descricao"
                            label="Desbloquear até :"
                          ></v-combobox>
                       </v-col>
                     </v-row>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="red darken-1"
                        text
                        @click="dialogoDisabilita = false"
                      >
                        Cancelar
                      </v-btn>

                          <v-btn
                          :disabled="editedItem.dayValidity === null"
                            color="green darken-1"
                            text
                            @click="criarExcecaoDeDesbloqueiodePauta()"
                          >
                            Desbloquear
                          </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

  <!--=========================FIM DO DIALOGO DE DESBLOQUEIO DA PAUTA============================================-->

  <!--======================DIALOGO DEPUBLICAOCAO=============================================--=======-->

            <template>
              <v-row justify="center">
                <v-dialog
                  v-model="dialog"
                  max-width="500"
                >
                  <v-card>
                    <v-card-title class="headline">Publicação da Pauta</v-card-title>

                    <v-card-text>
                     <strong> NOTA:</strong>----Ao publicar a pauta , não será possivel fazer alterações nas notas,<strong> pretende continuar</strong>?
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="red darken-1"
                        text
                        @click="dialog = false"
                      >
                        Cancelar
                      </v-btn>

                      <v-btn
                        color="green darken-1"
                        text
                        @click="PublicarPauta()"
                      >
                        Continuar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

  <!--======================FIM DIALOGO DE PUBLICAOCAO==============================================--=======-->

  <template v-if="listEstudantfromPauta.length">

    <v-form ref="form" v-model="formValid" lazy-validation>
      <v-container class="text-md-left">
        <v-row no-gutters>
          <v-col>
            <v-card class="d-flex flex-row mb-6" tile>
              <v-list flat>
                <v-btn @click="backTodisciplinList" class="mx-2" fab dark color="primary" v-on="on">
                  <v-icon dark>arrow_back</v-icon>
                </v-btn>
                <v-header>
                   <div style="text-align:center">
                  clica
                  <v-icon v-if="editedpk!==item.pkpauta" small class="mr-2">edit</v-icon>para lancar nota de
                  <strong>{{listEstudantfromPauta[0].disciplina}}</strong> na turma:
                  <strong>{{this.$store.state.turma}}</strong> <br>
                <strong>{{this.$store.state.lancarNotaDe}}   </strong>{{descricao_Prof}} : <strong>{{Professor}}</strong>

                </div>
                <div :style="estiloPauta"
                    v-if="$store.state.hasMessage"
                    :class="$store.state.classMessage"
                  >{{$store.state.textMessage}}</div>

                      <v-row>
                       
                        <v-col cols="12" md="7">
                            

                            <v-btn
                              class="ma-2 hidden-sm-and-down pb-0"
                              color="info"
                              style="float:right;"
                              v-if="pautaBloqueada"
                              text
                            >
                              Pauta bloqueada por {{(objBloqueioPauta!== null)?objBloqueioPauta.autor:''}} aos {{(objBloqueioPauta!== null)?objBloqueioPauta.data_:''}}

                            </v-btn>
                        </v-col>    

                        <v-col cols="12" md="2">
                        <v-btn  
                            class="ma-2 hidden-sm-and-down pb-0"
                             v-if="pautaBloqueada" 
                             @click="MostrarDialogoDisabilitar()" 
                             color="info"
                            style="float:right;"
                             >
                              Desbloquear
                            </v-btn>
                        </v-col>
                        
                        <v-col cols="12" md="3">
                           <v-btn
                              class="ma-2 hidden-sm-and-down pb-0"
                              color="info"
                              style="float:right;"
                               @click="irAvaliarComportamento()"
                            >
                              Avaliar comportamento

                            </v-btn>

                        </v-col>
                     </v-row>



                </v-header>
                <hr width="1200px" />
            <!--======================================== Clases Normais ou seja que não são de exames ===================== --->
                 <v-list-item-group v-model="item" color="primary" v-if="!exame">
                  <!--  3 trimestre  header -->
                   <v-row style="margin-left:50px">
                    <v-col cols="12" sm="12" md="1">N.</v-col>
                    <v-col cols="12" sm="12" md="2">Nome</v-col>

                    <v-col cols="12" sm="12" md="1">MAC</v-col>

                    <v-col cols="12" sm="12" md="1">P1</v-col>


                    <v-col cols="12" sm="12" md="1">MD</v-col>

                    <v-col cols="12" sm="12" md="1">PG</v-col>

                    <v-col cols="12" sm="12" md="2">Action</v-col>
                    
                    <v-col cols="12" sm="12" md="1">Autor</v-col>

                  </v-row>

                  <!-- end  list  header  -->

                  <v-list-item v-for="(item, i) in listEstudantfromPauta" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <!-- body 1  trimestre -->

                    <!-- body 3 trimestre -->
                    <v-row>
                      <v-col cols="12" sm="12" md="1">{{i+1}}.</v-col>

                      <v-col cols="12" sm="12" md="2">
                        <v-list-item-title v-text="item.nome"></v-list-item-title>
                      </v-col>

                      <v-col cols="12" sm="12" md="1">
                        <p v-if="editedpk!==item.pkpauta" class="text-lowercase">{{item.p3_notaMac}}</p>
                        <v-text-field :rules="notaRules"
                          v-if="editedpk===item.pkpauta"
                          v-model="editedItem.p3_notaMac"
                          single-line
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="1">
                        <p v-if="editedpk!==item.pkpauta" class="text-lowercase">{{item.p3_nota}}</p>
                        <v-text-field :rules="notaRules"
                          v-if="editedpk===item.pkpauta"
                          v-model="editedItem.p3_nota"
                          single-line
                        ></v-text-field>
                      </v-col>




                      <v-col cols="12" sm="12" md="1">
                        <p class="text-lowercase">{{item.p3_MD}}</p>
                      </v-col>


                      
                      <v-col cols="12" sm="12" md="1">
                        <p v-if="editedpk!==item.pkpauta" class="text-lowercase">{{item.pg}}</p>
                        <v-text-field :rules="notaRules"
                          v-if="editedpk===item.pkpauta"
                          v-model="editedItem.pg"
                          single-line
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="2">

                      <v-btn
                          color="red"
                          fab
                          x-small
                          dark
                          :disabled="btn_activacao1"
                          v-if="pautaBloqueada"
                          class="mr-2"
                          text
                        >
                          <v-icon>block</v-icon>
                        </v-btn>
                        <v-btn color="secondary"  fab x-small dark
                          v-if="!pautaBloqueada && editedpk!==item.pkpauta && !item.notas_transportadas && (parseInt(item.desistente) !== 6 && parseInt(item.desistente) !== 7)"
                          class="mr-2"
                          @click="bt_edit(item)"
                        >
                        <v-icon>edit</v-icon>

                        </v-btn>

                        <p  v-if="parseInt(item.desistente) === 6">Desistente</p>
                        <p  v-if="parseInt(item.desistente) === 7">Matricula Cancelada</p>

                        <v-btn color="primary"  fab x-small dark

                          v-if="editedpk===item.pkpauta"
                          @click="bt_save(editedItem)"
                        >
                         <v-icon>save_alt</v-icon>

                        </v-btn>

                      </v-col>

                      <v-col cols="12" sm="12" md="1">
                        <span style="font-size:8px;">{{item.p3_autor}}--{{item.p3_data2}}</span>
                      </v-col>
                      
                    </v-row>
                  </v-list-item>
                 </v-list-item-group> <!--======================================== Clases Normais ou seja que não são de exames FIM ===================== --->




                   <!--======================================== Clases de EXAME  ===================== --->
                 <v-list-item-group v-model="item" color="primary" v-if="exame">
                  <!--  3 trimestre  header -->
                   <v-row style="margin-left:50px">
                    <v-col cols="12" sm="12" md="1">N.</v-col>
                    <v-col cols="12" sm="12" md="3">Nome</v-col>

                    <v-col cols="12" sm="12" md="1">MAC</v-col>

                    <v-col cols="12" sm="12" md="1">P1</v-col>

                      <v-col cols="12" sm="12" md="1">MD</v-col>

                    <v-col cols="12" sm="12" md="1">EX</v-col>
                   

                    <v-col cols="12" sm="12" md="2">Action</v-col>

                    <v-col cols="12" sm="12" md="1">Autor</v-col>
                  </v-row>

                  <!-- end  list  header  -->

                  <v-list-item v-for="(item, i) in listEstudantfromPauta" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <!-- body 1  trimestre -->

                    <!-- body 3 trimestre -->
                    <v-row>
                      <v-col cols="12" sm="12" md="1">{{i+1}}.</v-col>

                      <v-col cols="12" sm="12" md="3">
                        <v-list-item-title v-text="item.nome"></v-list-item-title>
                      </v-col>

                      <v-col cols="12" sm="12" md="1">
                        <p v-if="editedpk!==item.pkpauta" class="text-lowercase">{{item.p3_notaMac}}</p>
                        <v-text-field :rules="notaRules"
                          v-if="editedpk===item.pkpauta"
                          v-model="editedItem.p3_notaMac"
                          single-line
                        ></v-text-field>
                      </v-col>


                       <v-col cols="12" sm="12" md="1">
                        <p v-if="editedpk!==item.pkpauta" class="text-lowercase">{{item.p3_nota}}</p>
                        <v-text-field :rules="notaRules"
                          v-if="editedpk===item.pkpauta"
                          v-model="editedItem.p3_nota"
                          single-line
                        ></v-text-field>
                      </v-col>


                      <v-col cols="12" sm="12" md="1">
                        <p class="text-lowercase">{{item.p3_MD}}</p>
                      </v-col>



                      <v-col cols="12" sm="12" md="1" >
                        <p v-if="editedpk!==item.pkpauta" class="text-lowercase">{{item.pg}}</p>
                        <v-text-field  :rules="notaRules"
                          v-if="editedpk===item.pkpauta"
                          v-model="editedItem.pg"
                          single-line
                        ></v-text-field>
                      </v-col>


                      <v-col cols="12" sm="12" md="2">
                        <v-btn
                          color="red"
                          fab
                          x-small
                          dark
                          :disabled="btn_activacao1"
                          v-if="pautaBloqueada"
                          class="mr-2"
                          text
                        >
                          <v-icon>block</v-icon>
                        </v-btn>
                        <v-btn color="secondary"  fab x-small dark
                          v-if="!pautaBloqueada && editedpk!==item.pkpauta && !item.notas_transportadas && (parseInt(item.desistente) !== 6 && parseInt(item.desistente) !== 7)"
                          class="mr-2"
                          @click="bt_edit(item)"
                        >
                        <v-icon>edit</v-icon>

                        </v-btn>

                        <p  v-if="parseInt(item.desistente) === 6">Desistente</p>
                        <p  v-if="parseInt(item.desistente) === 7">Matricula Cancelada</p>

                        <v-btn color="primary"  fab x-small dark

                          v-if="editedpk===item.pkpauta"
                          @click="bt_save(editedItem)"
                        >
                         <v-icon>save_alt</v-icon>

                        </v-btn>

                      </v-col>

                      <v-col cols="12" sm="12" md="1">
                        <span style="font-size:12px;">{{item.p3_autor}}---{{item.p3_data2}}</span>
                      </v-col>
                    </v-row>
                  </v-list-item>
                 </v-list-item-group> <!--======================================== Clases Normais ou seja que não são de exames FIM ===================== --->


              </v-list>
            </v-card>
          </v-col>
        </v-row>

      </v-container>
      </v-form >
    </template>
  </div>
  </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    anolectivo: ls.get('anolectivo'),
    estiloPauta: 'position:fixed;background-color:green;color:white;',
    formValid: true,
    on: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 20) || 'nota invalida',
      v => !isNaN(v) || 'not number ',

      v => (v.length <= 2) || 'valor inválido'

    ],
    roles: 'prof',
    exame: false,
    diasDesbloqueio: 
    [
      {id:1, descricao:'1 dia'},
      {id:2, descricao:'2 dias'},
      {id:3, descricao:'3 dias'},
      {id:4, descricao:'4 dias'},
      {id:5, descricao:'5 dias'}
    ],
    pautaBloqueada: false,
    objBloqueioPauta: null,
    overlay: false,
    text: '',
    editedpk: false,
    profediscinas: [],
    role_usuario: '',
    disciplinas: [],
    _classe: '',
    Professor: '',
    dialog: false,
    dialogoDisabilita: false,
    progresso: true,
    idanoacademico: 0,
    offset: true,
    descricao_Prof: '',
    tumaSelect: '',
    iddisciplina: 0,
    btn_description: '',
    publicar_status: false,
    idturma: 0,
    closeOnClick: true,
    item: 1,
    listaPautasBloquadas: [],
    btn_activacao1: false,
    btn_activacao2: false,
    btn_activacao3: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    editedIndex: -1,
    editedItem: {
      dayValidity: null,
      pkpauta: 0,
      p1_notaMac: 0,
      p1_nota: 0,
      p1_nota2: 0,
      p1_MD: 0,
      p2_notaMac: 0,
      p2_nota: 0,
      p2_nota2: 0,
      p2_MD: 0,
      p3_notaMac: 0,
      p3_nota: 0,
      p3_MD: 0,
      pg: 0,
      ca: 0,
      mfd: 0
    },
    pautaBloqueada: false,
    objBloqueioPauta: null,
    overlay:false,
  }),
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    role () {
      return ls.get('role')
    }
  },

  watch: {

    listaDeClassesPorLancarNotas () {
      this.$store.state.isloading = false
    }
  },
  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    
    // this.CarregActividades()
    this.turmaFindWithEstudanteCount('all')
    this.initprofdisc()
    this.role_usuario = ls.get('role')
  },

  methods: {
    classe (idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = '10ª Classe'
        this.exame = false
      }
      if (idanoacademico === 2) {
        this._classe = '11ª Classe'
        this.exame = false
      }
      if (idanoacademico === 3) {
        this._classe = '12ª Classe'
        this.exame = true
      }
      if (idanoacademico === 4) {
        this._classe = '13ª Classe'
        this.exame = false
      }

      this.idanoacademico = idanoacademico
    },
    loadprogressbar () {
      this.$store.state.isloading = true
    },

    bt_edit (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedpk = item.pkpauta
      this.editedItem.trimestre = this.$store.state.idperfilpauta
      this.editedItem.pkpauta = item.pkpauta

    },
    MostrarDialogo () {
      this.dialog = true
    },

    MostrarDialogoDisabilitar () {
      this.dialogoDisabilita = true
    },
    bt_save (editedItem) {
      // this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      editedItem.p1_MD = Math.round(
        (Number(editedItem.p1_notaMac) +
          Number(editedItem.p1_nota) +
          Number(editedItem.p1_nota2)) /
          3
      )
      editedItem.p2_MD = Math.round(
        (Number(editedItem.p2_notaMac) +
          Number(editedItem.p2_nota) +
          Number(editedItem.p2_nota2)) /
          3
      )
     editedItem.p3_MD =   Math.round(
        (Number(editedItem.p3_notaMac) +
          Number(editedItem.p3_nota)) /
          2
      )
      if (this.formValid) {
        this.save(editedItem)
        this.editedpk = 0
        
        // 
      }
      setTimeout(() => {}, 1000)
    },
    backTodisciplinList () {
      this.listEstudantfromPauta = []
    },
    backToTurmaList () {
      this.disciplinas = []
    },

    async turmaFindWithEstudanteCount (idclasse) {
      try {
        this.listaDeClassesPorLancarNotas = await axios
          .get('/turmaFindWithEstudanteCount/' + 'all') // idclasse JyUn JQ==
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        // this.isLoading = false
        this.progresso = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },
    async save (editedItem) {

       if( this.role === 'ROLE_ADM' ){
        this.estiloPauta = 'position:fixed;background-color:red;color:white;'
        this.$store.dispatch('textMessage', {msg: 'Não é permitido ao administrador Lançar Notas ou altera-las.',classMessage: 'msgError',timeout: 8000})
     }else{

      var params = {
        p1_notaMac: editedItem.p1_notaMac,
        p1_nota: editedItem.p1_nota,
        p1_nota2: editedItem.p1_nota2,
        p1_MD: editedItem.p1_MD,
        p2_notaMac: editedItem.p2_notaMac,
        p2_nota: editedItem.p2_nota,
        p2_nota2: editedItem.p2_nota2,
        p2_MD: editedItem.p2_MD,
        p3_notaMac: editedItem.p3_notaMac,
        p3_nota: editedItem.p3_nota,
        p3_MD: editedItem.p3_MD,
        pg: editedItem.pg,
        ca: editedItem.ca,
        mfd: editedItem.mfd,
        autor: ls.get('nomeUsuario'),
        p3_autor: ls.get('nomeUsuario'),
        pkpauta: editedItem.pkpauta,
        trimestre: 3
      }

      try {
        let results = await axios.post('/lancarNota', params).then(res => res.data)
        // this.text = msg[1].insertId
        try {
          if (results.affectedRows >= 1) {

            
             Object.assign(this.listEstudantfromPauta[this.editedIndex], editedItem)
            this.text = results.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', { msg: this.text,classMessage: 'msgSucess',timeout: 2000})
        
          }
        } catch (error) {

        }
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}

        if (this.editedIndex > -1) {
          //  Object.assign(this.estudantes[this.editedIndex], this.editedItem)
        } else {
          this.estudantes.push(this.editedItem)
        }
        //  this.close();
      } catch (error) {
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text + ' - ' + error,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
      }
     }
    },

     async  criarExcecaoDeDesbloqueiodePauta(){

        let params = 
          {
              id: null,
              disciplina: this.$store.state.objDisciplina,
              turma:this.$store.state.objturma,
              autor: ls.get('nomeUsuario'),
              dayValidity: this.editedItem.dayValidity,
              trimestre:3
          }

       try {
         let result = await axios
          .post('/exceptionMiniPautaInsertOrUpdate',params)
          .then(res => res.data)
        if(result.affectedRows >= 1){
            this.dialogoDisabilita = false
            this.pautaBloqueada = false
            this.$store.dispatch('textMessage', {msg: 'Pauta desbloqueada com sucesso',classMessage: 'msgError',timeout: 8000})
        }
       } catch (error) {
         this.estiloPauta = 'position:fixed;background-color:red;color:white;'
         this.$store.dispatch('textMessage', {msg: 'Ocorreu um erro ao tentar efectuar a operação',classMessage: 'msgError',timeout: 8000})
      }

    },

    async pautaByTurma (obj) {
      // carrega turma apartir de bauta  Turma
      this.$store.state.disciplina = obj.iddisciplina
      this.$store.state.objDisciplina = obj
      const payload =
        '{"iddisciplina":"' +
        obj.iddisciplina +
        '" , "pkturma":"' +
        obj.pkturma +
        '", "i_id":"' +
        ls.get('i_id') +
        '"  }'

      try {
        this.listEstudantfromPauta = await axios

          .get('/listEstudantfromPauta/' + payload)
          .then(res => res.data)
        this.MostraProfessor()
        this.VerificaExcecaoBloqueioPauta().then((res)=>{
          /**
           * Verifica se a disciplina da turma selecionada e do trimestre foi adicionada no desbloqueio excepcional
           */
          if(!res.length)
            this.CarregaPautas()
        }).catch(error=>{
          this.$store.dispatch('textMessage', {msg: 'Ocorreu um erro durante a verificação,por favor tente novamente',classMessage: 'msgError',timeout: 3000})
          this.CarregaPautas()
        })
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initprofdisc (search) {
      let payload
      try {
        if (!search) {
          payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.profediscinas = await axios
          .get('/professordiscFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
async VerificaExcecaoBloqueioPauta () {
      this.overlay = true
      try {
        let params =
        {
          disciplina: this.$store.state.objDisciplina,
          turma: this.$store.state.objturma,
          trimestre: this.TrimestreToInteger(this.$store.state.lancarNotaDe)
        }

          return  await axios
          .post('/ObterExceptionMinipauta', params)
          .then(res => res.data)
        
      } catch (error) {
        this.overlay = false
        this.$store.dispatch('textMessage', {msg: error,classMessage: 'msgError',timeout: 3000})
      }
      finally{
        this.overlay = false
      }
    },

    TrimestreToInteger(value){
      switch (value) {
        case "1º Trimestre":
          return 1;
          case "2º Trimestre":
          return 2;
          case "3º Trimestre":
          return 4;
      
        default:
          break;
      }
    },

    HabilitaBotoes (valor) {
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '1º Trimestre')) {
        this.btn_activacao1 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '2º Trimestre')) {
        this.btn_activacao2 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '3º Trimestre')) {
        this.btn_activacao3 = valor
      }
    },


    async PublicarPauta () {
      const valores =
          {
            turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
            disciplina: this.$store.state.disciplina,
            trimestre: this.$store.state.lancarNotaDe,
            bloquear: 1,
            publicar: 1,
            idControlopauta: 0
          }

      // Consumindo a API
      try {
        let valor = await axios
          .post('/bloquearPauta', valores)
          .then(res => res.data)
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
        this.dialog = false

        this.$store.state.bloqueado.push(valores)
        // this.$store.state.bloqueado = []
        // CarregaPauta
        this.verificaPautas()
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },

    async DesbloquearPauta () {
      // Verificando se o Id esta disponivel
      if (this.$store.state.Controlopauta != null) {
        // CONSUMINDO A API ----  Passando a Id
        const valores =
            {
              turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
              disciplina: this.$store.state.disciplina,
              trimestre: this.$store.state.lancarNotaDe,
              bloquear: 0,
              publicar: 0,
              idControlopauta: this.$store.state.Controlopauta
            }

        try {
          let valor = await axios
            .post('/bloquearPauta', valores)
            .then(res => res.data)
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          this.dialog = false

          this.$store.state.bloqueado = []
          // CarregaPauta
          this.verificaPautas()

          this.dialogoDisabilita = false
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },

    MostraProfessor () {
      let valor = this.profediscinas.filter(d => d.iddisciplina === this.$store.state.disciplina)
      if (valor.length) {
        this.Professor = valor[0].nome
        this.descricao_Prof = 'disciplina atrbuida ao Professor'
      } else {
        this.Professor = 'Sem Professor Associado'
        this.descricao_Prof = ''
      }
    },

    async CarregaPautas () {
      this.overlay = true
      try {
        let params =
        {
          disciplina: this.$store.state.disciplina,
          turma: this.$store.state.objturma,
          trimestre: 3
        }

          let results = await axios
          .post('/ListarPautaBloqueada', params)
          .then(res => res.data)
          this.overlay = false
        if(results.length){
           this.objBloqueioPauta = results[0]
           this.pautaBloqueada = true;
           this.overlay = false
        }
        else
          this.pautaBloqueada = false
      } catch (error) {
        this.overlay = false
        this.$store.dispatch('textMessage', {msg: error,classMessage: 'msgError',timeout: 3000})
      }
      finally{
        this.overlay = false
      }
    },

    HabilitaBotoes (valor) {
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '1º Trimestre')) {
        this.btn_activacao1 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '2º Trimestre')) {
        this.btn_activacao2 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '3º Trimestre')) {
        this.btn_activacao3 = valor
      }
    },

    verificaPautas () {
      this.listaPautasBloquadas = this.$store.state.bloqueado.filter(block => block.turma === this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma && block.disciplina === this.$store.state.disciplina && block.publicar === 1 && block.bloquear === 1 && block.trimestre === this.$store.state.lancarNotaDe)
      if (this.listaPautasBloquadas.length) {
        this.HabilitaBotoes(true)

        this.$store.state.Controlopauta = this.listaPautasBloquadas[0].idControlopauta
        if (ls.get('role') === 'ROLE_PROF') {
          this.publicar_status = true
          this.btn_description = 'Mini Pauta Bloqueada'
        } else {
          this.publicar_status = true
          this.HabilitaBotoes(false)
          this.btn_description = 'Mini Pauta Bloqueada'
        }
      } else {
        this.publicar_status = false
        this.btn_description = 'Bloquear'
        this.HabilitaBotoes(false)
      }
    },

    async findDisciplinaInProfDisc (obj) {
      this.disciplinas = []
      this.$store.state.turma = obj.descricao
      this.$store.state.objturma = obj
      try {
        this.disciplinas = await axios

          .get('/findDisciplinaInProfDisc/' + obj.pkTurma)
          .then(res => res.data)
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    irParaValiacao (item) {
      this.$store.state.objPauta = item
      this.$store.state.rotas = 'lancar-trimestre-tres'
      this.$router.push('avalicacao-comportamento')
    },
    irAvaliarComportamento () {
      this.$store.state.rotas = 'lancar-trimestre-tres'
      this.$store.state.Pautas = this.listEstudantfromPauta
      this.$router.push('comportamento')
    }
  }
}
</script>
